export default __webpack_public_path__ + "static/media/custom-feed-icon.46ea877b.svg";